import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const issuedInventoryAPI = {
    getAll: async (
        page,
        pageSize,
        searchTerm,
        stockItemId,
        parentDestinationId,
        subcategoryDestinationId,
        issuedBy,
        startDate,
        endDate,
        isReturned,
        canReturn,
        warehouseId,
        locationId
    ) => {
        try {
            const { data } = await api.get('/api/issued-inventory-items/', {
                params: { 
                    page, 
                    pageSize,
                    searchTerm,
                    stockItemId,
                    parentDestinationId,
                    subcategoryDestinationId,
                    issuedBy,
                    startDate,
                    endDate,
                    isReturned,
                    canReturn,
                    warehouseId,
                    locationId
                }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get issued inventory items error:');
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/issued-inventory-items/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get issued inventory item error:');
            throw error;
        }
    },

    returnItem: async (id, returnData) => {
        try {
            const { data } = await api.post(`/api/issued-inventory-items/${id}/return/`, returnData);
            return data;
        } catch (error) {
            handleApiError(error, 'Return issued inventory item error:');
            throw error;
        }
    },

    getReturnReasonChoices: async () => {
        try {
            const { data } = await api.get('/api/issued-inventory-items/return-reason-choices/');
            return data;
        } catch (error) {
            handleApiError(error, 'Get return reason choices error:');
            throw error;
        }
    },

    // Get issued inventory report data (JSON response)
    getIssuedInventoryReport: async (params) => {
        try {
            const config = {
                params: params
            };

            const { data } = await api.get('/api/reports/issued-inventory/', config);
            return data;
        } catch (error) {
            handleApiError(error, 'Get issued inventory report error:');
            throw error;
        }
    },

    // Generate and download issued inventory report file (CSV or Excel)
    generateIssuedInventoryReport: async (
        startDate,
        endDate,
        destinationFilters,
        categories,
        searchTerm,
        fileType
    ) => {
        try {
            const response = await api.get('/api/reports/issued-inventory/export/', {
                params: {
                    start_date: startDate,
                    end_date: endDate,
                    destinationFilters,
                    categories,
                    searchTerm,
                    format: fileType
                },
                responseType: 'blob'
            });

            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary link element
            const link = document.createElement('a');
            link.href = url;

            // Create timestamp in format YYYYMMDD_HHMMSS
            const timestamp = new Date().toISOString()
                .replace(/[:\-T]/g, '')
                .slice(0, 14);
            const fileName = `issued_inventory_report_${timestamp}.${fileType === 'excel' ? 'xlsx' : 'csv'}`;
            link.setAttribute('download', fileName);

            // Append to body, click, and clean up
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            return true;
        } catch (error) {
            handleApiError(error, 'Generate issued inventory report error:');
            return false;
        }
    }
};